import React from "react";
import MetricCard from "./MetricCard";

export default function MetricCardGroup({ metrics, title="", columns = 5, direction = "row" }) {
  if (direction === "col") {
    return (
      <div className="flex flex-col gap-4">
        {metrics.map((m, i) => (
          <MetricCard key={i} {...m} />
        ))}
      </div>
    );
  }
  // Use explicit Tailwind classes for supported column counts
  const gridColsClass = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
  }[columns] || "grid-cols-5";
  return (
    <div className="mt-0">
      {title.length>0&&
      <div className="my-3">
        {title}
      </div>
      }
      <div className={`grid ${gridColsClass} gap-4`}>
        {metrics.map((m, i) => (
          <MetricCard key={i} {...m} />
        ))}
      </div>
      </div>
  );
} 